@if (login.loginStep === 'CREDENTIALS') {
  <app-login-desktop-credentials-step></app-login-desktop-credentials-step>
}

@if (login.loginStep === 'MFA') {
  <app-login-desktop-mfa-step></app-login-desktop-mfa-step>
}
